import { Grid } from '@material-ui/core';
import { GridItem } from 'react-grid-dnd';
import styled from 'styled-components';

export const AddGraph = styled(Grid)`
  cursor: pointer;
  margin-top: -1px;
  position: relative;
  ${({ left }) => `left: ${left};`}
`;

export const GraphItem = styled(GridItem)`
  ${({ iseditable }) =>
    iseditable ? 'cursor: grab;' : 'cursor: auto !important;'}
`;

export const GraphsContainer = styled.div`
  padding-left: 1rem;
  padding-right: 1rem;
  position: relative;
`;
